
import { Component, Vue } from 'vue-property-decorator'
import { CONFIGAPI } from '@/api/config'
import { ConfigModule } from '@/store/modules/config'
import UpdateDialog from './updateBuildDialog.vue'
import { getuserCurrentApp } from '@/utils/cookies'

@Component({
  name: 'tutorConfig',
  components: {
    UpdateDialog
  }
})
export default class extends Vue {
  private tableData = []
  private columns = [
    { field: 'id', title: 'ID', width: 100 },
    { field: 'name', title: '基地名称', width: 200 },
    { field: 'place_name', title: '所属地区', width: 200 },
    { field: 'floors', title: '楼层' }
  ]

  private updateType = 'add' // 新建/编辑类型 add-新建，edit-编辑
  private currentNode = {} // 当前选择的节点
  private total = 0 // 总条数
  private currentPage = 1
  private pageSize = 10

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  mounted() {
    this.getTableData()
  }

  // 获取表格数据
  private async getTableData() {
    await CONFIGAPI.getBuildingData({
      place: this.$route.params.id,
      page: this.currentPage,
      page_size: this.pageSize,
      app_id: this.userCurrentApp
    }).then((res) => {
      if (res.stat === 1) {
        this.total = res.data.count
        this.tableData = res.data.lists
      }
    }).catch((error) => {
      console.log('发生错误！', error)
    })
  }

  // 新增
  private handleCreate() {
    this.updateType = 'add'
    ConfigModule.ToggleDialogStatus({
      name: 'buildAddDialog',
      value: true
    })
  }

  // 编辑
  private handleEdit(data: any) {
    this.updateType = 'edit'
    this.currentNode = data
    ConfigModule.ToggleDialogStatus({
      name: 'buildAddDialog',
      value: true
    })
  }

  // 删除
  private handleDelete(data: any) {
    this.$confirm(`确定要删除当前基地么？【${data.name}】`)
      .then(_ => {
        CONFIGAPI.delBuilding({
          id: data.id
        }, {
          app_id: this.userCurrentApp
        }).then((res) => {
          if (res.stat === 1) {
            this.$message.success(res.data)
            this.getTableData()
          }
        }).catch((error) => {
          console.log('发生错误！', error)
        })
      })
      .catch(_ => {})
  }

  // 子组件接口调用成功后
  private handleSuccess() {
    this.getTableData()
  }

  private handleSizeChange(val: number) {
    this.currentPage = 1
    this.pageSize = val
    this.getTableData()
  }

  private handleCurrentChange(val: number) {
    this.currentPage = val
    this.getTableData()
  }
}
